import { RADEnvironmentProxy } from 'radpresentation.htmlclient.defaultviewextensions';

// PDO-Typ und Operationsname des serverseitigen Download-Statistik-Endpunkts.
const KURSUNTERLAGEN_GENERATOR_PD_TYPE = 'ONV.ONV.KursunterlagenGenerator';
const OP_DOWNLOAD_OVERVIEW             = 'GetKursunterlagenDownloadOverview';

/** Download-Kennzahlen eines Landesverbands (Backend-Kontrakt, siehe KursunterlagenDownloadRowDto). */
export interface IKursunterlagenDownloadRow {
    landesverbandId: number;
    name:            string;
    /** Anzahl der KursunterlagenGenerator-Entitaeten (= erzeugte Downloads) des Landesverbands. */
    downloads:       number;
}

/** Backend-Kontrakt: JSON von ONV.ONV.KursunterlagenGenerator.GetKursunterlagenDownloadOverview */
export interface IKursunterlagenDownloadOverview {
    generatedAt?: string;
    rows:         IKursunterlagenDownloadRow[];
}

/**
 * Ruft die Download-Statistik je Landesverband ab. Die Auswertung erfolgt
 * landesverbands-uebergreifend (serverseitig unter SuperUserGuard), daher genuegt
 * ein einziger Aufruf fuer die gesamte Tabelle.
 */
export function fetchKursunterlagenDownloadOverview(): JQueryPromise<IKursunterlagenDownloadOverview | null> {
    return RADEnvironmentProxy.getInstance().callStaticOperation({
        pdTypeName:          KURSUNTERLAGEN_GENERATOR_PD_TYPE,
        operationName:       OP_DOWNLOAD_OVERVIEW,
        operationParameters: [],
        contextParameters:   {},
    }).then((result) => parseKursunterlagenDownloadOverview(result?.returnValue));
}

/**
 * Normalisiert den Rueckgabewert der Operation. <c>returnValue</c> ist je nach
 * Serialisierung bereits ein Objekt oder ein JSON-String.
 */
export function parseKursunterlagenDownloadOverview(returnValue: unknown): IKursunterlagenDownloadOverview | null {
    let raw: unknown = returnValue;

    if (typeof raw === 'string') {
        try { raw = JSON.parse(raw); }
        catch { return null; }
    }

    if (raw == null || typeof raw !== 'object') return null;
    const obj = raw as IKursunterlagenDownloadOverview;
    if (!Array.isArray(obj.rows)) return null;
    return obj;
}
